<section class="custom_plp__container">
  <ng-container *ngTemplateOutlet="commonProps.isLoading ? catalogLoading : productListPage"></ng-container>

  <ng-template #catalogLoading>
    <app-catalog-loading
      [isMobile]="commonProps.isMobile"
      [isTablet]="commonProps.isTablet"
      [isDesktop]="commonProps.isDesktop"
      [isLandScapeTablet]="commonProps.isLandScapeTablet"
    >
    </app-catalog-loading>
  </ng-template>

  <ng-template #productListPage>
    <app-catalog-products-list
      [searchQuery]="commonProps.searchQuery"
      [products]="commonProps.products"
      [totalCount]="commonProps.productsTotalCount"
      [recommendedProducts]="commonProps.recommendedProducts"
      [recommendedProductsType]="commonProps.recommendedProductsType"
      [storyblokSeoContent]="storyResponse"
      [isCustomPLPPage]="true"
      [queryParams]="commonProps.queryParams"
      [isMobileOrTablet]="commonProps.isMobile || commonProps.isTablet"
      [isDesktop]="commonProps.isDesktop"
      [isMobile]="commonProps.isMobile"
      [isZeroResult]="commonProps.isZeroResult"
      [hasFilters]="commonProps.hasFilters"
      [isExpired]="commonProps.isExpired"
    >
    </app-catalog-products-list>
  </ng-template>
</section>
